// Auth
export const user_signed_in = 'user_signed_in';
export const user_signed_out = 'user_signed_out';
export const login_error_handler = 'login_error_handler';

// Admin
export const admin_modal_toggled = 'admin_modal_toggled';

// Shoutouts
export const shoutout_feed_initialized = 'shoutout_feed_initialized';
export const shoutouts_requested = 'shoutouts_requested';
export const shoutouts_returned = 'shoutouts_returned';
export const shoutout_returned = 'shoutout_returned';
export const profile_shoutout_returned = 'profile_shoutout_returned';
export const shoutouts_before_returned = 'shoutouts_before_returned';
export const new_shoutout_received = 'new_shoutout_received';
export const all_shoutouts_loaded = 'all_shoutouts_loaded';
export const set_focus = 'set_focus';
export const show_image = 'show_image';
export const set_text_field_focus = 'set_text_field_focus';
export const shoutout_deleted = 'shoutout_deleted';
export const shoutout_updated = 'shoutout_updated';

// hotkeys
export const show_send_shoutout_modal = 'show_send_shoutout_modal';
export const set_send_shoutout_modal_profile_user = 'set_send_shoutout_modal_profile_user';
export const show_send_shoutout_modal_with_user = 'show_send_shoutout_modal_with_user';

// Comments
export const comments_requested = 'comments_requested';
export const comments_returned = 'comments_returned';
export const comment_received = 'comment_received';
export const set_show_comments = 'set_show_comments';
export const set_show_delete_comment = 'set_show_delete_comment';
export const comment_deleted = 'comment_deleted';
export const comment_updated = 'comment_updated';

// Users
export const current_user_returned = 'current_user_returned';
export const users_requested = 'users_requested';
export const users_returned = 'users_returned';
export const new_user_received = 'new_user_received';
export const set_user_profile = 'set_user_profile';
export const set_user_shoutouts_as_read = 'set_user_shoutouts_as_read';
export const user_updated = 'user-updated';

// Profile
export const profile_shoutouts_requested = 'profile_shoutouts_requested';
export const all_profile_shoutouts_loaded = 'all_profile_shoutouts_loaded';
export const user_profile_opened = 'user_profile_opened';
export const user_shoutouts_returned = 'user_shoutouts_returned';
export const change_filter = 'change_filter';

// Teams
export const teams_requested = 'teams_requested';
export const teams_returned = 'teams_returned';

// Tags
export const tags_returned = 'tags_returned';
export const tag_received = 'tag_received';
export const tag_updated = 'tag_updated';
export const tag_deleted = 'tag_deleted';

// Achievements
export const achievements_returned = 'achievements_returned';
export const achievement_earned = 'achievement_earned';
export const earned_achievements_returned = 'earned_achievements_returned';

// Personalization
export const dark_mode_toggled = 'dark_mode_toggled';

// TV Mode Options
export const get_filtered_shoutouts = 'get_filtered_shoutouts';
export const modal_next = 'modal_next';
export const modal_back = 'modal_back';
export const time_frame_tv_filter_toggled = 'time_frame_tv_filter_toggled';
export const recipient_tv_filter_toggled = 'recipient_tv_filter_toggled';
export const show_codecommit_stats = 'show_codecommit_stats';
export const get_tvmode_queue = 'get_tvmode_queue';
export const update_queue = 'update_queue';
export const pick_winner = 'pick_winner';
export const add_to_alert_queue = 'add_to_alert_queue';
export const pop_from_alert_queue = 'pop_from_alert_queue';
export const add_to_new_shoutouts = 'add_to_new_shoutouts';
export const pop_from_new_shoutouts = 'pop_from_new_shoutouts';
export const leave_pick_winner_mode = 'leave_pick_winner_mode';
export const code_input_changed = 'code_input_changed';
export const display_type_changed = 'display_type_changed';
export const set_time_frame_range = 'set_time_frame_range';
export const set_selected_users = 'set_slected_users';
export const clear_modal = 'clear_modal';
export const connect_to_tv = 'connect_to_tv';

// Metrics
export const get_user_metrics = 'get_user_metrics';

// Toast
export const show_toast = 'show_toast';
export const hide_toast = 'hide_toast';
export const get_toast_content = 'get_toast_content';
export const show_help = 'show_help';



// WEBPACK FOOTER //
// ./src/actions/types.js